import React, { createContext, useCallback, useContext, useMemo, useState } from "react";
import usePolling, { keepIfSame } from "@/hooks/usePolling";
import { api } from "@/lib/api";

const POLL_MS = 60_000;
const StoreContext = createContext({ status: null, refresh: () => {} });
export const useStoreStatus = () => useContext(StoreContext);

const whenAt = (n) => (n.when === "today" ? `at ${n.time}` : `${n.when} at ${n.time}`);

export function opensLabel(status) {
  if (!status || status.is_open) return "";
  if (!status.next_open) return "Closed for now";
  return `Opens ${whenAt(status.next_open)}`;
}

export function closedCheckoutLabel(status) {
  if (!status?.next_open) return "We're closed right now — back soon";
  return `We're closed — open ${whenAt(status.next_open)}`;
}

export function StoreProvider({ children }) {
  const [status, setStatus] = useState(null);
  const refresh = useCallback(() => api.get("/store/status").then((r) => setStatus(keepIfSame(r.data))).catch(() => { /* keep last known */ }), []);
  usePolling(refresh, POLL_MS);
  const value = useMemo(() => ({ status, refresh }), [status, refresh]);
  return <StoreContext.Provider value={value}>{children}</StoreContext.Provider>;
}
